// extracted by mini-css-extract-plugin
module.exports = {"copyClipboard":"mIndex_copyClipboard__jcpgs"};